<template>
	<div id="lcr_change_request__listing__block" >
			<b-col class="pt-3">
				<b-row v-if="this.logsData.length == 0">
					<b-col class="collapse-content-wrapper">
						<b-alert :show="true" variant="success">
						<strong>No changes were made in this section.  Be sure to check other sections.</strong>
						</b-alert>
					</b-col>
				</b-row>
				<b-row v-else>
					<b-col class="collapse-content-wrapper">
						<b-alert :show="true" variant="warning" v-if="stepText">
							<strong><font-awesome-icon icon="exclamation-triangle" />&nbsp;&nbsp;Last changes submitted for <span style="text-transform:uppercase;">{{stepText}}</span>.</strong>
						</b-alert>
					</b-col>
				</b-row>

				<b-row v-for="(logItem, y) in this.logsData" v-bind:key="'logitem-'+y+'-'+Math.random()">
					<b-col class="collapse-content-wrapper">
						<div class="lcr-summary__label">{{$t(`auditLog.laneClosureRequest.${logItem.label}`)}}</div>
						<div v-for="line in logItem.getContent()" class="lcr-summary__value">
							<span style="float:left;" v-if="line.faType"><font-awesome-icon v-if="line.faType" :icon="line.faType" :class="'mr-2 ' + line.faType"></font-awesome-icon></span><div class="lcr-summary__value-wrapper" v-html="line.text"></div></div>
					</b-col>
				</b-row>
			</b-col>
	</div>
</template>

<script>
import LcrChangeRequestList from '../models/LcrChangeRequestList';
import LaneClosureRequest from '../models/LaneClosureRequest';
export default {
	name: 'LcrChangeRequestListingBlock',
	props: ['batchDetail', 'adminView', 'logs', 'lcr', 'step', 'stepText'],
	data() {
		return {
			expand: false,
			LaneClosureRequest
		}
	},
	computed: {
		logsData() {
			let foo = new LcrChangeRequestList(this.logs, this.$t, this).getStepFields(this.step);

			return foo;
		},

		batchTitle() {
			if (!this.adminView) {
				if (this.batchDetail.auditTypeId == 1) {
					return this.$t('changeRequest.laneClosureRequest.NewRequest');
				}
				else if (this.batchDetail.auditTypeId == 2) {
					return this.$t('changeRequest.laneClosureRequest.UpdatedRequest');
				}
				else {
					return this.batchDetail.notes;
				}
			} else {
				return this.batchDetail.notes;
			}
		},

		companyColor() {
			if (this.batchDetail.organizationType == "city") {
				return "flex-grow-1 bg-primary-x-light collapsible-heading__value color-column";
			} else {
				return "flex-grow-1 bg-secondary-light collapsible-heading__value color-column";
			}
		},
		companyColorDropdownIcon() {
			if (this.batchDetail.organizationType == "city") {
				return "bg-primary-x-light collapsible-heading__toggle";
			} else {
				return "bg-secondary-light collapsible-heading__toggle";
			}
		},
		companyTree() {
			if (this.batchDetail.organizationNamePath) {
				let path = this.batchDetail.organizationNamePath;
				path = path.split('|');
				path.pop();
				path.shift();
				return path.reverse();
			}
			return [this.batchDetail.organizationName];
		}
	},
	watch: {
		logsData: {
			immediate: true,
			handler(val) {
				if (val) {
					console.log(this.step, val.length);
					if (val.length) {
						this.$emit('update:logCount', val.length)
					} else {
						this.$emit('update:logCount', 0)
					}
				} else {
					this.$emit('update:logCount', 0)
				}
			}
		}
	}
}
</script>

<style>

</style>